import "./ToolExpertiseTechnologyStack.module.css";
import Header from "@/reusable_sections/Header";
import Technologyexpertisehero from "./sections/Technologyexpertisehero";
import PmsIntegration from "./sections/PmsIntegration";
import SystemsComparison from "./sections/SystemsComparison";
import Bookingenginecomparison from "./sections/Bookingenginecomparison";
import Integration from "./sections/Integration";
import AuditMethodology from "./sections/AuditMethodology";
import Casestudies from "./sections/Casestudies";
import Revenuefaq from "./sections/Revenuefaq";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function ToolExpertiseTechnologyStackPage() {
  return <div>
      <Header />
      <Technologyexpertisehero />
      <PmsIntegration />
      <SystemsComparison />
      <Bookingenginecomparison />
      <Integration />
      <AuditMethodology />
      <Casestudies />
      <Revenuefaq />
      <Services />
      <Footer />
    </div>;
}